"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const core_1 = require("@nestjs/core");
const fs_1 = require("fs");
const dotenv = tslib_1.__importStar(require("dotenv"));
const path_1 = require("path");
const app_module_1 = require("./app/app.module");
dotenv.config();
async function bootstrap() {
    // Ensure uploads directory exists
    const uploadsDir = (0, path_1.join)(process.cwd(), 'uploads', 'medical');
    (0, fs_1.mkdirSync)(uploadsDir, { recursive: true });
    // rawBody: true makes req.rawBody available for webhook signature verification
    // (Twilio HMAC-SHA1, Meta HMAC-SHA256) without an extra body-parser middleware.
    const app = await core_1.NestFactory.create(app_module_1.AppModule, { rawBody: true });
    // Serve uploaded files as static assets at /api/uploads/*
    app.useStaticAssets((0, path_1.join)(process.cwd(), 'uploads'), { prefix: '/api/uploads' });
    // Global prefix
    app.setGlobalPrefix('api');
    const configuredOrigins = (process.env.CORS_ORIGINS ?? '')
        .split(',')
        .map((origin) => origin.trim())
        .filter(Boolean);
    app.enableCors({
        origin: [
            /^http:\/\/localhost(:\d+)?$/,
            /^https:\/\/.*\.netlify\.app$/,
            'https://vaidban.tm',
            ...configuredOrigins,
        ],
        credentials: true,
    });
    // Global validation pipe (class-validator)
    app.useGlobalPipes(new common_1.ValidationPipe({
        whitelist: true,
        forbidNonWhitelisted: false,
        transform: true,
        transformOptions: { enableImplicitConversion: true },
    }));
    const port = process.env.API_PORT || 3000;
    await app.listen(port);
    common_1.Logger.log(`AyurCRM API running on: http://localhost:${port}/api`, 'Bootstrap');
}
bootstrap();
